import React, { Component } from "react";

const sentences = [
  "We provide *tailored formation* for technical teams that want to improve.",
  "We build *mobile* and *web applications* for big and small companies.",
  "We give back to the community by organizing *technical conferences* and contributing to *open source.*",
  "We have experience breathing life into *legacy code* and making it shine again.",
  "We love *React* , *Erlang/Elixir* and *Symfony* and like to teach other people how to take advantage of them."
];

export function slice(sentence, idx) {
  const tokens = sentence.split(" ");
  const words = tokens.slice(0, idx);
  return words;
}

export function findSegments(words) {
  let segments = [];
  let inSegment = false;
  let currentSegment = [];
  words.forEach((word, idx) => {
    if (word.indexOf("*") === 0) {
      inSegment = true;
      currentSegment = [idx];
    }
    if (inSegment) {
      if (
        word.lastIndexOf("*") === word.length - 1 ||
        idx === words.length - 1
      ) {
        currentSegment.push(idx);
        inSegment = false;
        segments.push(currentSegment);
        currentSegment = [];
      }
    }
  });
  return segments;
}

export function makeTree(words) {
  const segments = findSegments(words);
  segments.reverse().forEach(segment => {
    words.splice(
      segment[0],
      1,
      words[segment[0]].slice(1, words[segment[0].length - 1])
    );
    if (words[segment[1]].lastIndexOf("*") === words[segment[1]].length - 1) {
      words.splice(
        segment[1],
        1,
        words[segment[1]].slice(0, words[segment[1]].length - 1)
      );
    }
    const strongWords = words.slice(segment[0], segment[1] + 1);
    words.splice(segment[0], 1 + segment[1] - segment[0], {
      mod: "strong",
      tokens: strongWords
    });
  });
  return words;
}

export function transform(sentence, index) {
  const sliced = slice(sentence, index);
  const tree = makeTree(sliced);
  return tree;
}

function shuffle(a) {
  for (let i = a.length; i; i--) {
    let j = Math.floor(Math.random() * i);
    [a[i - 1], a[j]] = [a[j], a[i - 1]];
  }
}

export default class Messages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCount: 0,
      sentenceCount: 0
    };
    shuffle(sentences);
    this.sentences = sentences;
    this.updateCount = this.updateCount.bind(this);
    this.updateSentence = this.updateSentence.bind(this);
  }

  componentDidMount() {
    this.countdown = setTimeout(this.updateCount, 200);
  }

  componentWillUnmount() {
    clearInterval(this.countdown);
  }

  updateSentence() {
    if (this.state.sentenceCount === this.sentences.length - 1) {
      this.setState({ sentenceCount: 0 });
    } else {
      this.setState({ sentenceCount: this.state.sentenceCount + 1 });
    }
    this.setState({ showCount: 0 });
    this.countdown = setTimeout(this.updateCount, 200);
  }

  updateCount() {
    const tokens = this.sentences[this.state.sentenceCount].split(" ");
    if (this.state.showCount > tokens.length) {
      this.countdown = setTimeout(this.updateSentence, 5000);
    } else {
      this.setState({ showCount: this.state.showCount + 1 });
      this.countdown = setTimeout(this.updateCount, 200);
    }
  }

  renderSentence() {
    const tree = transform(
      this.sentences[this.state.sentenceCount],
      this.state.showCount
    );
    const renderToken = (tok, idx) => {
      if (typeof tok === "string") {
        return <span key={idx}> {tok} </span>;
      } else {
        return (
          <span key={idx} className="c-intro__strong">
            {tok.tokens.map((t, idx2) => {
              return (
                <span key={idx2}>
                  {idx2 !== 0 ? " " : ""}
                  {t}
                </span>
              );
            })}
          </span>
        );
      }
    };
    return <div>{tree.map((token, idx) => renderToken(token, idx))}</div>;
  }

  render() {
    return (
      <section className="c-intro-messages">
        <div className="container">
          <div className="o-lettering o-lettering__ultra">
            We build software.
          </div>
          <div className="c-intro--and">{/* and */}</div>
          <div className="c-intro">{this.renderSentence()}</div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/organisms/Messages.js